module.exports = __webpack_public_path__ + "img/wayfinder-mobile-ar-view-en.cd5273b4.webp";